module.exports = __webpack_public_path__ + "img/voice-square.2cb497ee.svg";